import { ReactComponent as LockPriceIcon } from './lockPrice.svg';
import { ReactComponent as LockDateIcon } from './lockDate.svg';

export const MarketplaceIcons = {
  LockPriceIcon,
  LockDateIcon,
};
